import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './footer.module.scss';

@classic
@classNames(styles.component)
export default class SharedFullFlyoutFooter extends Component {}
